import { Button, colors, ModalActions, ModalHeader, Typography } from '@ui-components/neo.tax';
import { ReactComponent as AlarmBellRing } from '@ui-components/neo.tax/dist/icons/alarm-bell-ring.svg';

import { StyledModal } from './merge-projects-modal.styled';

export const MergeProjectsModal = ({
  analyticIds,
  copy,
  isOpen,
  loading,
  setIsOpen,
  submit,
}: {
  isOpen: boolean;
  submit: () => Promise<void>;
  loading: boolean;
  setIsOpen: (open: boolean) => void;
  analyticIds: { confirmMergeProjectsId: string; cancelMergeProjectsId: string };
  copy: React.ReactNode;
}): React.ReactElement | null => (
  <StyledModal isOpen={isOpen}>
    <ModalHeader
      icon={<AlarmBellRing width={24} color={colors.blue[600]} />}
      iconBgColor={colors.blue[50]}
      title={
        <Typography fontSize="base" fontWeight="semibold">
          Merge Projects
        </Typography>
      }
      copy={copy}
    />
    <ModalActions hasTopBorder={false}>
      <Button
        disabled={loading}
        id={analyticIds.cancelMergeProjectsId}
        variant="white"
        rounded="regular"
        size="base"
        onClick={(): void => setIsOpen(false)}
      >
        Cancel
      </Button>
      <Button
        disabled={loading}
        id={analyticIds.confirmMergeProjectsId}
        variant="primary"
        rounded="regular"
        size="base"
        onClick={submit}
      >
        {loading ? 'Merging...' : 'Continue'}
      </Button>
    </ModalActions>
  </StyledModal>
);
